/**
 * React hook that subscribes to TOAST_NOTIFICATION events on ShellEventBus
 * and renders them via react-toastify's toast() function (feat-69).
 *
 * Severity mapping:
 *   info  → toast.info
 *   warn  → toast.warning
 *   error → toast.error
 */

import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { shellEventBus } from '../events/eventBus';
import { TOAST_AUTO_CLOSE_MS } from '../../constants/timing';

const TOAST_OPTIONS = { autoClose: TOAST_AUTO_CLOSE_MS } as const;

/**
 * React hook that subscribes to TOAST_NOTIFICATION events on ShellEventBus
 * and renders them via react-toastify's toast() function.
 */
export function useToastSubscriber(): void {
  useEffect(() => {
    const unsubscribe = shellEventBus.on('TOAST_NOTIFICATION', event => {
      const { message, severity } = event.payload;
      switch (severity) {
        case 'warn':
          toast.warning(message, TOAST_OPTIONS);
          break;
        case 'error':
          toast.error(message, TOAST_OPTIONS);
          break;
        case 'info':
        default:
          toast.info(message, TOAST_OPTIONS);
          break;
      }
    });

    return unsubscribe;
  }, []); // stable — runs once on mount
}
